export const apiConstants = {
  url: "/api/peopleCourseWeekRegistration"
};
